import React, { useState, useEffect } from "react";
//import "react-simple-keyboard/build/css/index.css";
import Sidebar from "components/sidebar";
import { map } from "lodash";
import {
  ApiUrl,
  ApiKey,
  AlertTypes,
  SessionKey,
  WebUrl,
} from "../../util/Constant";
import { useHistory, useLocation } from "react-router-dom";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import ApiEngine from "../../util/ApiEngine";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  setBusy,
  setIdle,
  showMessage,
  showResponseMessage,
} from "../../redux/AppAction";
import {
  createFormBody,
  isObjectEmpty,
  stringIsNullOrEmpty,
} from "../../util/Util";
import ContentHeader from "components/content/header";
import PlusMinusMaxButton from "../../components/custom/PlusMinusMaxButton";

const ReferralEdit = (props) => {
  const { t, i18n } = useTranslation();
  const _history = useHistory();
  const _location = useLocation();
  const _dispatch = useDispatch();
  const [referralCodeId, setReferralCodeId] = useState();
  const [remark, setRemark] = useState("");
  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [product, setProduct] = useState({});
  const [products, setProducts] = useState([]);
  const [valueList, setValueList] = useState([]);
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [showCategoryKeyboard, setShowCategoryKeyboard] = useState(false);
  const [initCheck, setInitCheck] = useState(false);
  const [selectedValue, setSelectedValue] = useState("0000");
  const [currentIndexOfValue, setCurrentIndexOfValue] = useState(0);
  const [selectedProductId, setSelectedProductId] = useState(-1);
  const [selectedCategoryId, setSelectedCategoryId] = useState(-1);
  const [selectedCategoryTitle, setSelectedCategoryTitle] = useState("");
  const [selectedBonusOrComm, setSelectedBonusOrComm] = useState("");
  const [selectedProductsIndex, setSelectedProductsIndex] = useState(0);
  const { control, handleSubmit, setValue, errors, getValues } = useForm();
  const [contentTitle, setContentTitle] = useState("");
  var selectedLanguage = localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ? 
  localStorage.getItem(SessionKey._LANGUAGE) : 'en' ;

  const backgroundLightMaxButton = "rgb(255 193 89)";
  const backgroundDarkMaxButton = "rgb(255 193 89 / 50%)";

  useEffect(() => {
    init(true);
  }, [_location.state]);

  useEffect(() => {
    if (!_location.state) {
      setContentTitle("NEW_REFERRAL_DETAIL");
      products.map((product, index) => {
        setValue("bonus-" + product.productId, 0.0);
        setValue("commission-" + product.productId, 0.0);
        setValue("clubFee-" + product.productId, 0.0);
        if(document.getElementById("product-" + product.productId + "-bonus") !== null) {
          document.getElementById("product-" + product.productId + "-bonus").style.background = backgroundLightMaxButton;
        }
  
        if(document.getElementById("product-" + product.productId + "-commission") !== null) {
          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
        }
  
        if(document.getElementById("product-" + product.productId + "-clubFee") !== null) {
          document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundLightMaxButton;
        }
  

      });
      categories.map((category, index) => {
        setValue("category-bonus-" + category.id, 0.0);
        setValue("category-commission-" + category.id, 0.0);
        setValue("category-clubFee-" + category.id, 0.0);
      });
    } else {
      setContentTitle("EDIT_REFERRAL_DETAIL");
      setReferralCodeId(_location.state.id);
      if (!isObjectEmpty(_location.state.referralCodeDetail)) {
        _location.state.referralCodeDetail.memberReferralInfos.map((info) => {
          setValue("bonus-" + info.productId, info.bonus);
          setValue("commission-" + info.productId, info.commission);
          setValue("clubFee-" + info.productId, info.clubFee);

          if(info.bonus == 0){
            if(document.getElementById("product-" + info.productId + "-bonus") !== null) {
              document.getElementById("product-" + info.productId + "-bonus").style.background = backgroundLightMaxButton;
            }
          }
          else if(info.bonus == info.maxBonus){
            if(document.getElementById("product-" + info.productId + "-bonus") !== null) {
              document.getElementById("product-" + info.productId + "-bonus").style.background = backgroundDarkMaxButton;
            }
          }
          
          if(info.commission == 0){
            if(document.getElementById("product-" + info.productId + "-commission") !== null) {
              document.getElementById("product-" + info.productId + "-commission").style.background = backgroundLightMaxButton;
            }
          }
          else if(info.commission == info.maxCommission){
            if(document.getElementById("product-" + info.productId + "-commission") !== null) {
              document.getElementById("product-" + info.productId + "-commission").style.background = backgroundDarkMaxButton;
            }
          }
     
          if(info.clubFee == 0){
            if(document.getElementById("product-" + info.productId + "-clubFee") !== null) {
              document.getElementById("product-" + info.productId + "-clubFee").style.background = backgroundLightMaxButton;
            }
          }
          else if(info.clubFee == info.maxClubFee) {
            if(document.getElementById("product-" + info.productId + "-clubFee") !== null) {
              document.getElementById("product-" + info.productId + "-clubFee").style.background = backgroundDarkMaxButton;
            }
          }
        });
        setRemark(_location.state.referralCodeDetail.remark);
      }
    }
  }, [initCheck]);

  useEffect(() => {
    init(false);
  }, [(localStorage.getItem(SessionKey._LANGUAGE) && localStorage.getItem(SessionKey._LANGUAGE) != 'undefined' ?
  localStorage.getItem(SessionKey._LANGUAGE) : 'en')]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const init = async (init) => {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_MEMBER_PRODUCT_RATES
    );
    let uplineProductRates = [];
    let processedProducts = [];
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      uplineProductRates = responseJson[ApiKey._API_DATA_KEY];
    } else {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
    }

    var productResponseJson = await ApiEngine.get(
      ApiUrl._API_GET_ASSIGNED_MEMBER_PRODUCT
    );
    if (productResponseJson[ApiKey._API_SUCCESS_KEY]) {
      productResponseJson[ApiKey._API_DATA_KEY].products.map((product) => {
        let uplineProduct = uplineProductRates.filter(
          (i) => i.accountProductId == product.accountProductId
        )[0];
        processedProducts.push({
          id: product.id,
          productId: product.productId,
          accountProductId: product.accountProductId,
          productName: product.productName + (product.useGroupRate ? " *" : ""),
          assigned: product.assigned,
          bonus: product.bonus,
          commission: product.commission,
          clubFee: product.clubFee,
          categoryName: product.categoryName,
          maxBonus: uplineProduct != null ? uplineProduct.bonus : 0,
          maxCommission: uplineProduct != null ? uplineProduct.commission : 0,
          maxClubFee: uplineProduct != null ? uplineProduct.clubFee : 0,
          useGroupRate: product.useGroupRate,
        });
      });
    } else {
      throw productResponseJson[ApiKey._API_MESSAGE_KEY];
    }

    setProduct(
      products["length"] == 0
        ? processedProducts[0]
        : processedProducts.find((x) => x["id"] == product["id"])
    );
    setProducts(processedProducts);

    let tempCategoryData = [];
    let categoryJson = await ApiEngine.get(
      ApiUrl._API_GET_PRODUCT_CATEGORY_DESKTOP +
        "?selectedLanguage=" +
        selectedLanguage
    );
    if (categoryJson[ApiKey._API_DATA_KEY]) {
      tempCategoryData = categoryJson[ApiKey._API_DATA_KEY];
    }
    setActiveTab(tempCategoryData[0]["id"]);
    let tempObj = {};
    let tempHighestMaxBonus = 0.0;
    let tempHighestMaxComm = 0.0;
    let tempHighestMaxClubFee = 0.0;
    let tempNonEmptyCategories = [];
    tempCategoryData.map((category, index) => {
      if (
        processedProducts.filter(
          (x) =>
            x.categoryName === category.originalTitle &&
            (x.maxBonus > 0 || x.maxCommission > 0 || x.maxClubFee > 0)
        ).length > 0 ||
        category.originalTitle === "All"
      ) {
        tempNonEmptyCategories.push(category);
      }
      if (!tempObj[category.originalTitle]) {
        tempObj[category.originalTitle] = {
          bonusValues: [],
          commValues: [],
          clubFeeValues: [],
          highestMaxBonus: 0,
          highestMaxComm: 0,
          highestMaxClubFee: 0,
        };
      }
      processedProducts
        .filter((x) => x.categoryName === category.originalTitle)
        .map((product, i) => {
          if (i === 0) {
            tempHighestMaxBonus = product.maxBonus;
            tempHighestMaxComm = product.maxCommission;
            tempHighestMaxClubFee = product.maxClubFee;
          }
          if (!tempObj[category.originalTitle][product.productName])
            tempObj[category.originalTitle][product.productName] = {
              bonusValues: [],
              commValues: [],
              clubFeeValues: [],
            };
          if (product.maxBonus > tempHighestMaxBonus) {
            tempHighestMaxBonus = product.maxBonus;
          }
          if (product.maxCommission > tempHighestMaxComm) {
            tempHighestMaxComm = product.maxCommission;
          }
          if (product.maxClubFee > tempHighestMaxClubFee) {
            tempHighestMaxClubFee = product.maxClubFee;
          }
          if (product.maxBonus > 0) {
            for (
              var i = 0.0;
              parseFloat(i.toFixed(2)) <=
              parseFloat(product.maxBonus.toFixed(2));
              i += 0.1
            ) {
              i = i * 100;
              i = Math.round(i);
              i = i / 100;
              i = parseFloat(i.toFixed(2));

              if (i === 0.0) {
                tempObj[category.originalTitle][
                  product.productName
                ].bonusValues.push("-");
              }

              tempObj[category.originalTitle][
                product.productName
              ].bonusValues.push(i);
            }
          }
          if (product.maxCommission > 0) {
            for (
              var i = 0.0;
              parseFloat(i.toFixed(2)) <=
              parseFloat(product.maxCommission.toFixed(2));
              i += 0.1
            ) {
              i = i * 100;
              i = Math.round(i);
              i = i / 100;
              i = parseFloat(i.toFixed(2));

              if (i === 0.0) {
                tempObj[category.originalTitle][
                  product.productName
                ].commValues.push("-");
              }

              tempObj[category.originalTitle][
                product.productName
              ].commValues.push(i);
            }
          }
          if (product.maxClubFee > 0) {
            for (
              var i = 0.0;
              parseFloat(i.toFixed(2)) <=
              parseFloat(product.maxClubFee.toFixed(2));
              i += 5.0
            ) {
              i = i * 100;
              i = Math.round(i);
              i = i / 100;
              i = parseFloat(i.toFixed(2));

              if (i === 0.0) {
                tempObj[category.originalTitle][
                  product.productName
                ].clubFeeValues.push("-");
              }

              tempObj[category.originalTitle][
                product.productName
              ].clubFeeValues.push(i);
            }
          }
        });

      tempObj[category.originalTitle]["highestMaxBonus"] =
        tempHighestMaxBonus;
      tempObj[category.originalTitle]["highestMaxComm"] = tempHighestMaxComm;
      tempObj[category.originalTitle]["highestMaxClubFee"] =
        tempHighestMaxClubFee;

      for (
        var i = 0.0;
        parseFloat(i.toFixed(2)) <=
        parseFloat(tempHighestMaxBonus.toFixed(2));
        i += 0.1
      ) {
        i = i * 100;
        i = Math.round(i);
        i = i / 100;
        i = parseFloat(i.toFixed(2));

        if (i === 0.0) {
          tempObj[category.originalTitle].bonusValues.push("-");
        }
        tempObj[category.originalTitle].bonusValues.push(i);
      }
      for (
        var i = 0.0;
        parseFloat(i.toFixed(2)) <= parseFloat(tempHighestMaxComm.toFixed(2));
        i += 0.1
      ) {
        i = i * 100;
        i = Math.round(i);
        i = i / 100;
        i = parseFloat(i.toFixed(2));

        if (i === 0.0) {
          tempObj[category.originalTitle].commValues.push("-");
        }
        tempObj[category.originalTitle].commValues.push(i);
      }
      for (
        var i = 0.0;
        parseFloat(i.toFixed(2)) <=
        parseFloat(tempHighestMaxClubFee.toFixed(2));
        i += 5.0
      ) {
        i = i * 100;
        i = Math.round(i);
        i = i / 100;
        i = parseFloat(i.toFixed(2));

        if (i === 0.0) {
          tempObj[category.originalTitle].clubFeeValues.push("-");
        }
        tempObj[category.originalTitle].clubFeeValues.push(i);
      }
    });
    setActiveTab(tempNonEmptyCategories[0]["id"]);

    setValueList(tempObj);
    setCategories(tempNonEmptyCategories);
    setInitCheck(true);
  };

  const submitForm = async (data) => {
    _dispatch(setBusy());
    //if (expiryDate == '' || expiryDate == null) {
    //    _dispatch(showResponseMessage(false, t("EXPIRY_DATE_INVALID")));
    //}
    let params = {
      //expiryDate: expiryDate,
      remark: remark,
    };

    if (!stringIsNullOrEmpty(referralCodeId)) {
      params["id"] = referralCodeId;
    }

    Object.keys(data).map((key, value) => {
      if (data[key] !== '-') {
        params[key] = data[key];
      }
      else {
        params[key] = 0.00;
      }
    });

    let formBody = createFormBody(params);
    let responseJson = await ApiEngine.post(
      ApiUrl._API_GENERATE_MEMBER_REFERRAL_CODE,
      formBody
    );
    _dispatch(
      showMessage({
        type: responseJson[ApiKey._API_SUCCESS_KEY]
          ? AlertTypes._SUCCESS
          : AlertTypes._ERROR,
        content: t(responseJson[ApiKey._API_MESSAGE_KEY]),
        onConfirm: () => {
          _history.replace({
            pathname: WebUrl._URL_REFERRAL_CODE,
            state: {
              id: responseJson[ApiKey._API_DATA_KEY]["id"],
            },
          });
        },
      })
    );
    _dispatch(setIdle());
  };

  function onEditReferralKeyPress(key) {
    let valueStr = selectedValue;
    let tempCurrentIndex = currentIndexOfValue;
    let tempSlicedValueStr = "";
    let tempValue = 0;
    if (valueStr === "0000") {
      tempCurrentIndex = valueStr.length - 1;
      setCurrentIndexOfValue(tempCurrentIndex);
    } else {
      tempSlicedValueStr = valueStr.substring(
        tempCurrentIndex + 1,
        valueStr.length
      );
    }
    if (key !== "{bksp}" && key !== "{enter}") {
      if (tempCurrentIndex > 0) {
        valueStr =
          valueStr.substring(0, tempCurrentIndex) + tempSlicedValueStr + key;
        setCurrentIndexOfValue(tempCurrentIndex - 1);
        setSelectedValue(valueStr);
      } else {
        valueStr =
          valueStr.substring(0, tempCurrentIndex) + tempSlicedValueStr + key;
        if (valueStr.charAt(valueStr.length - 1) !== "0") {
          if (parseInt(valueStr.charAt(valueStr.length - 1)) < 5) {
            valueStr = valueStr.substring(0, 3) + "0";
          } else {
            if (parseInt(valueStr.charAt(valueStr.length - 1)) === 9) {
              if (valueStr === "9999") {
                valueStr = "10000";
              } else {
                valueStr = "" + (parseInt(valueStr) + 1);
              }
            } else {
              valueStr =
                valueStr.substring(0, 2) +
                (parseInt(valueStr.charAt(valueStr.length - 2)) + 1) +
                "0";
            }
          }
        }
        setSelectedValue(valueStr);
        if (valueStr.length === 5) {
          tempValue = parseFloat(
            valueStr.substring(0, 3) +
              "." +
              valueStr.substring(3, valueStr.length)
          );
        } else {
          tempValue = parseFloat(
            valueStr.substring(0, 2) +
              "." +
              valueStr.substring(2, valueStr.length)
          );
        }
        if (selectedBonusOrComm === "bonus") {
          if (tempValue > products[selectedProductsIndex]["maxBonus"]) {
            tempValue = products[selectedProductsIndex]["maxBonus"];
          }
        } else if (selectedBonusOrComm === "commission") {
          if (tempValue > products[selectedProductsIndex]["maxCommission"]) {
            tempValue = products[selectedProductsIndex]["maxCommission"];
          }
        } else if (selectedBonusOrComm === "clubFee") {
          if (tempValue > products[selectedProductsIndex]["maxClubFee"]) {
            tempValue = products[selectedProductsIndex]["maxClubFee"];
          }
        } else {
          //error
        }
        setValue("" + selectedBonusOrComm + "-" + selectedProductId, tempValue);
        setTimeout(() => setShowKeyboard(false), 500);
        setTimeout(() => setSelectedValue("0000"), 600);
      }
    } else if (key === "{enter}") {
      if (valueStr.charAt(valueStr.length - 1) !== "0") {
        if (parseInt(valueStr.charAt(valueStr.length - 1)) < 5) {
          valueStr = valueStr.substring(0, 3) + "0";
        } else {
          if (parseInt(valueStr.charAt(valueStr.length - 1)) === 9) {
            if (valueStr === "9999") {
              valueStr = "10000";
            } else {
              valueStr = "" + (parseInt(valueStr) + 1);
            }
          } else {
            valueStr =
              valueStr.substring(0, 2) +
              (parseInt(valueStr.charAt(valueStr.length - 2)) + 1) +
              "0";
          }
        }
      }
      if (valueStr.length === 5) {
        tempValue = parseFloat(
          valueStr.substring(0, 3) +
            "." +
            valueStr.substring(3, valueStr.length)
        );
      } else {
        tempValue = parseFloat(
          valueStr.substring(0, 2) +
            "." +
            valueStr.substring(2, valueStr.length)
        );
      }
      if (selectedBonusOrComm === "bonus") {
        if (tempValue > products[selectedProductsIndex]["maxBonus"]) {
          tempValue = products[selectedProductsIndex]["maxBonus"];
        }
      } else if (selectedBonusOrComm === "commission") {
        if (tempValue > products[selectedProductsIndex]["maxCommission"]) {
          tempValue = products[selectedProductsIndex]["maxCommission"];
        }
      } else if (selectedBonusOrComm === "clubFee") {
        if (tempValue > products[selectedProductsIndex]["maxClubFee"]) {
          tempValue = products[selectedProductsIndex]["maxClubFee"];
        }
      } else {
        //error
      }
      setValue("" + selectedBonusOrComm + "-" + selectedProductId, tempValue);
      setTimeout(() => setShowKeyboard(false), 500);
      setTimeout(() => setSelectedValue("0000"), 600);
    } else {
      setSelectedValue("0000");
    }
  }

  function onCategoryKeyPress(key) {
    let valueStr = selectedValue;
    let tempCurrentIndex = currentIndexOfValue;
    let tempSlicedValueStr = "";
    let tempValue = 0;
    if (valueStr === "0000") {
      tempCurrentIndex = valueStr.length - 1;
      setCurrentIndexOfValue(tempCurrentIndex);
    } else {
      tempSlicedValueStr = valueStr.substring(
        tempCurrentIndex + 1,
        valueStr.length
      );
    }
    if (key !== "{bksp}" && key !== "{enter}") {
      if (tempCurrentIndex > 0) {
        valueStr =
          valueStr.substring(0, tempCurrentIndex) + tempSlicedValueStr + key;
        setCurrentIndexOfValue(tempCurrentIndex - 1);
        setSelectedValue(valueStr);
      } else {
        valueStr =
          valueStr.substring(0, tempCurrentIndex) + tempSlicedValueStr + key;
        if (valueStr.charAt(valueStr.length - 1) !== "0") {
          if (parseInt(valueStr.charAt(valueStr.length - 1)) < 5) {
            valueStr = valueStr.substring(0, 3) + "0";
          } else {
            if (parseInt(valueStr.charAt(valueStr.length - 1)) === 9) {
              if (valueStr === "9999") {
                valueStr = "10000";
              } else {
                valueStr = "" + (parseInt(valueStr) + 1);
              }
            } else {
              valueStr =
                valueStr.substring(0, 2) +
                (parseInt(valueStr.charAt(valueStr.length - 2)) + 1) +
                "0";
            }
          }
        }
        setSelectedValue(valueStr);
        if (valueStr.length === 5) {
          tempValue = parseFloat(
            valueStr.substring(0, 3) +
              "." +
              valueStr.substring(3, valueStr.length)
          );
        } else {
          tempValue = parseFloat(
            valueStr.substring(0, 2) +
              "." +
              valueStr.substring(2, valueStr.length)
          );
        }
        if (selectedBonusOrComm === "bonus") {
          products
            .filter((x) => x.categoryName === selectedCategoryTitle)
            .map((product, index) => {
              if (tempValue > product["maxBonus"]) {
                setValue("bonus-" + product.productId, product["maxBonus"]);
              } else {
                setValue("bonus-" + product.productId, tempValue);
              }
            });
        } else if (selectedBonusOrComm === "commission") {
          products
            .filter((x) => x.categoryName === selectedCategoryTitle)
            .map((product, index) => {
              if (tempValue > product["maxCommission"]) {
                setValue(
                  "commission-" + product.productId,
                  product["maxCommission"]
                );
              } else {
                setValue("commission-" + product.productId, tempValue);
              }
            });
        } else if (selectedBonusOrComm === "clubFee") {
          products
            .filter((x) => x.categoryName === selectedCategoryTitle)
            .map((product, index) => {
              if (tempValue > product["maxClubFee"]) {
                setValue("clubFee-" + product.productId, product["maxClubFee"]);
              } else {
                setValue("clubFee-" + product.productId, tempValue);
              }
            });
        } else {
          //error
        }
        setValue(
          "category-" + selectedBonusOrComm + "-" + selectedCategoryId,
          tempValue
        );
        setTimeout(() => setShowCategoryKeyboard(false), 500);
        setTimeout(() => setSelectedValue("0000"), 600);
      }
    } else if (key === "{enter}") {
      if (valueStr.charAt(valueStr.length - 1) !== "0") {
        if (parseInt(valueStr.charAt(valueStr.length - 1)) < 5) {
          valueStr = valueStr.substring(0, 3) + "0";
        } else {
          if (parseInt(valueStr.charAt(valueStr.length - 1)) === 9) {
            if (valueStr === "9999") {
              valueStr = "10000";
            } else {
              valueStr = "" + (parseInt(valueStr) + 1);
            }
          } else {
            valueStr =
              valueStr.substring(0, 2) +
              (parseInt(valueStr.charAt(valueStr.length - 2)) + 1) +
              "0";
          }
        }
      }
      if (valueStr.length === 5) {
        tempValue = parseFloat(
          valueStr.substring(0, 3) +
            "." +
            valueStr.substring(3, valueStr.length)
        );
      } else {
        tempValue = parseFloat(
          valueStr.substring(0, 2) +
            "." +
            valueStr.substring(2, valueStr.length)
        );
      }
      if (selectedBonusOrComm === "bonus") {
        products
          .filter((x) => x.categoryName === selectedCategoryTitle)
          .map((product, index) => {
            if (tempValue > product["maxBonus"]) {
              setValue("bonus-" + product.productId, product["maxBonus"]);
            } else {
              setValue("bonus-" + product.productId, tempValue);
            }
          });
      } else if (selectedBonusOrComm === "commission") {
        products
          .filter((x) => x.categoryName === selectedCategoryTitle)
          .map((product, index) => {
            if (tempValue > product["maxCommission"]) {
              setValue(
                "commission-" + product.productId,
                product["maxCommission"]
              );
            } else {
              setValue("commission-" + product.productId, tempValue);
            }
          });
      } else if (selectedBonusOrComm === "clubFee") {
        products
          .filter((x) => x.categoryName === selectedCategoryTitle)
          .map((product, index) => {
            if (tempValue > product["maxClubFee"]) {
              setValue("clubFee-" + product.productId, product["maxClubFee"]);
            } else {
              setValue("clubFee-" + product.productId, tempValue);
            }
          });
      } else {
        //error
      }
      setValue(
        "category-" + selectedBonusOrComm + "-" + selectedCategoryId,
        tempValue
      );
      setTimeout(() => setShowCategoryKeyboard(false), 500);
      setTimeout(() => setSelectedValue("0000"), 600);
    } else {
      setSelectedValue("0000");
    }
  }

  function handleSelectCatValue(bonusOrComm, categoryId, categoryTitle, value) {
    if (value !== '-') {
        value *= 100;
        value = Math.round(value);
        value /= 100;

        products.filter(x => x.categoryName === categoryTitle).map((product, index) => {
            let tempBonusOrComm = bonusOrComm.substring(0, 1).toUpperCase() + bonusOrComm.substring(1, bonusOrComm.length);
            if (value > product["max" + tempBonusOrComm]) {
                setValue(bonusOrComm + '-' + product.productId, product["max" + tempBonusOrComm]);

                if (document.getElementById("product-" + product.productId + "-" + bonusOrComm) !== null) {
                    document.getElementById("product-" + product.productId + "-" + bonusOrComm).style.background = backgroundDarkMaxButton;
                  }

            }
            else if (value == product["max" + tempBonusOrComm]) {
                setValue(bonusOrComm + '-' + product.productId, value);

                if (document.getElementById("product-" + product.productId + "-" + bonusOrComm) !== null) {
                    document.getElementById("product-" + product.productId + "-" + bonusOrComm).style.background = backgroundDarkMaxButton;
                  }
            }
            else {
                setValue(bonusOrComm + '-' + product.productId, value);

                if (document.getElementById("product-" + product.productId + "-" + bonusOrComm) !== null) {
                    document.getElementById("product-" + product.productId + "-" + bonusOrComm).style.background = backgroundLightMaxButton;
                  }
            }
        });
    }
    else {
        products.filter(x => x.categoryName === categoryTitle).map((product, index) => {
            setValue(bonusOrComm + '-' + product.productId, '-');

            if (document.getElementById("product-" + product.productId + "-" + bonusOrComm) !== null) {
                document.getElementById("product-" + product.productId + "-" + bonusOrComm).style.background = backgroundLightMaxButton;
              }
        });
    }
    setValue('category-' + bonusOrComm + '-' + categoryId, value);
  }

  function handleSelectValue(bonusOrComm, productId, value, maxValue) {
    if (value !== "-") {
      value *= 100;
      value = Math.round(value);
      value /= 100;
    }

    //let tempValue = parseFloat(value);
    if(value == maxValue){
      document.getElementById("product-" + productId + "-" + bonusOrComm).style.background = backgroundDarkMaxButton;
    }
    else {
      document.getElementById("product-" + productId + "-" + bonusOrComm).style.background = backgroundLightMaxButton;
    }
    
    setValue("" + bonusOrComm + "-" + productId, value);
  }

  function handleCatBtn(bonusOrComm, categoryId, categoryTitle, value) {
    if (value !== "-") {
      value *= 100;
      value = Math.round(value);
      value /= 100;

      products.filter(x => x.categoryName === categoryTitle).map((product, index) => {
        let tempBonusOrComm = bonusOrComm.substring(0, 1).toUpperCase() + bonusOrComm.substring(1, bonusOrComm.length);
        if (value > product["max" + tempBonusOrComm]) {
            setValue(bonusOrComm + '-' + product.productId, product["max" + tempBonusOrComm]);
        }
        else if (value == product["max" + tempBonusOrComm]){
            setValue(bonusOrComm + '-' + product.productId, value);

            if (document.getElementById("product-" + product.productId + "-" + bonusOrComm) !== null) {
              document.getElementById("product-" + product.productId + "-" + bonusOrComm).style.background = backgroundDarkMaxButton;
              }
        }
        else {
            setValue(bonusOrComm + '-' + product.productId, value);

            if (document.getElementById("product-" + product.productId + "-" + bonusOrComm) !== null && document.getElementById("category-" + categoryId + "-" + bonusOrComm) !== null) {
              document.getElementById("product-" + product.productId+ "-" + bonusOrComm).style.background = backgroundLightMaxButton;
            }
        }
      });
    }
    else {
      products
      .filter((x) => x.categoryName === categoryTitle)
      .map((product, index) => {
        setValue(bonusOrComm + "-" + product.productId, "-");
      });
    }
  }

  function handleMaxBtn(productId, maxBonus, maxComm, maxClubFee, bonusOrComm) {
    document.getElementById("product-" + productId + "-" + bonusOrComm).style.background = backgroundDarkMaxButton;

    if (bonusOrComm === "bonus") {
      setValue("bonus-" + productId, maxBonus);
    } else if (bonusOrComm === "commission") {
      setValue("commission-" + productId, maxComm);
    } else if (bonusOrComm === "clubFee") {
      setValue("clubFee-" + productId, maxClubFee);
    }
  }

  function handleMaxCatBtn(categoryId, categoryTitle, bonusOrComm) {
    let tempHighestBonus = 0.0;
    let tempHighestComm = 0.0;
    let tempHighestMaxClubFee = 0.0;

    products
      .filter((x) => x.categoryName === categoryTitle)
      .map((product, index) => {

        if (document.getElementById("product-" + product.productId + '-' + bonusOrComm) !== null && document.getElementById("category-" + categoryId + "-" + bonusOrComm) !== null ) {
          document.getElementById("product-" + product.productId + '-' + bonusOrComm).style.background = backgroundDarkMaxButton;
        }

        if (bonusOrComm === "bonus") {
          if (product.maxBonus > tempHighestBonus) {
            tempHighestBonus = product.maxBonus;
          }
          if (100.0 > product.maxBonus) {
            setValue("bonus-" + product.productId, product["maxBonus"]);
          } else {
            setValue("bonus-" + product.productId, 100.0);
          }
        } else if (bonusOrComm === "commission") {
          if (product.maxCommission > tempHighestComm) {
            tempHighestComm = product.maxCommission;
          }
          if (100.0 > product.maxCommission) {
            setValue(
              "commission-" + product.productId,
              product["maxCommission"]
            );
          } else {
            setValue("commission-" + product.productId, 100.0);
          }
        } else if (bonusOrComm === "clubFee") {
          if (product.maxClubFee > tempHighestMaxClubFee) {
            tempHighestMaxClubFee = product.maxClubFee;
          }
          if (100.0 > product.maxClubFee) {
            setValue("clubFee-" + product.productId, product["maxClubFee"]);
          } else {
            setValue("clubFee-" + product.productId, 100.0);
          }
        }
      });

    if (bonusOrComm === "bonus") {
      setValue("category-bonus-" + categoryId, tempHighestBonus);
    } else if (bonusOrComm === "commission") {
      setValue("category-commission-" + categoryId, tempHighestComm);
    } else if (bonusOrComm === "clubFee") {
      setValue("category-clubFee-" + categoryId, tempHighestMaxClubFee);
    }
  }

  function checkValueForLowest(value) {
    if (value !== "-") {
      if (value === 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  function checkValueForHighest(value, category, bonusOrComm) {
    if (value !== "-") {
      if (bonusOrComm === "bonus") {
        if (value === valueList[category.originalTitle].highestMaxBonus) {
          return false;
        } else {
          return true;
        }
      } else if (bonusOrComm === "commission") {
        if (value === valueList[category.originalTitle].highestMaxComm) {
          return false;
        } else {
          return true;
        }
      } else if (bonusOrComm === "clubFee") {
        if (value === valueList[category.originalTitle].highestMaxClubFee) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  const ReferralCodeDetailForm = () => {
    return (
      <div className="template-box" id="payment-method-box">
        <div className="form-divider">
          <div>
            <h4 className="font-15 mb-3">{t("REMARK")}:</h4>
            <input
              type="text"
              name="amount"
              className="form-white-input"
              placeholder={t("REMARK")}
              defaultValue={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </div>
          <div></div>
        </div>
        <Nav className="nav nav-tabs mt-5" id="my-tabs">
          {categories &&
            categories.length > 0 &&
            categories.filter((x) => x.originalTitle !== "All").length > 1 &&
            map(categories, (category, index) => {
              if (
                products.filter(
                  (x) => x.categoryName === category.originalTitle
                ).length > 0 ||
                category.originalTitle === "All"
              ) {
                return (
                  <NavItem
                    Key={index}
                    className={classnames({
                      active: activeTab === category.id,
                    })}
                  >
                    <NavLink
                      className={
                        "font-14 " +
                        classnames({
                          active: activeTab === category.id,
                        })
                      }
                      onClick={() => {
                        toggleTab(category.id);
                      }}
                    >
                      {t(category.originalTitle)}
                    </NavLink>
                  </NavItem>
                );
              }
            })}
        </Nav>
        {initCheck ? (
          <form onSubmit={handleSubmit(submitForm)}>
            <TabContent activeTab={activeTab}>
              {categories &&
                categories.length > 0 &&
                activeTab !==
                  categories.find((x) => x.originalTitle === "All").id &&
                map(categories, (category, index) => {
                  if (
                    products.filter(
                      (x) =>
                        x.categoryName === category.originalTitle &&
                        (x.maxBonus > 0 ||
                          x.maxCommission > 0 ||
                          x.maxClubFee > 0)
                    ).length > 0
                  ) {
                    return (
                      <TabPane tabId={category.id}>
                        <div className="text-white mt-4">
                          <div className="referral-edit-box font-14 mt-2">
                            <div>
                              <h6 className="text-gold">
                                {t(category.originalTitle)}
                              </h6>
                            </div>

                            <div className="font-14">
                              {(products.filter(
                                (x) =>
                                  x.categoryName === category.originalTitle &&
                                  x.maxBonus > 0
                              ).length > 0 ||
                                category.originalTitle === "All") && (
                                <div className="referral-edit-details mb-3">
                                  <Controller
                                    control={control}
                                    name={"category-bonus-" + category.id}
                                    defaultValue={0}
                                    render={({ onChange, value }) => {
                                      let valueNotLowest =
                                        checkValueForLowest(value);
                                      let valueNotHighest =
                                        checkValueForHighest(
                                          value,
                                          category,
                                          "bonus"
                                        );

                                      return (
                                        <>
                                          <div className="first font-12">
                                            {t("BONUS")}
                                            <br />
                                            {t("MAX") + " : "}
                                            {valueList &&
                                            valueList[category.originalTitle]
                                              ? valueList[
                                                  category.originalTitle
                                                ].highestMaxBonus.toFixed(2)
                                              : "0"}
                                            %
                                          </div>

                                          <PlusMinusMaxButton
                                            buttonSection="plusminus"
                                            styleValueMinus={valueNotLowest}
                                            onClickMinus={(e) => {
                                              if (valueNotLowest === true) {
                                                if (value !== "-") {
                                                  value -= 0.1;
                                                  value *= 100;
                                                  value = Math.round(value);
                                                  value /= 100;
                                                } else {
                                                  value = 0.0;
                                                }
                                                setValue(
                                                  "category-bonus-" +
                                                    category.id,
                                                  value
                                                );
                                                handleCatBtn(
                                                  "bonus",
                                                  category.originalTitle,
                                                  value
                                                );
                                              }
                                            }}
                                            styleValuePlus={valueNotHighest}
                                            onClickPlus={(e) => {
                                              if (valueNotHighest === true) {
                                                if (value !== "-") {
                                                  value += 0.1;
                                                  value *= 100;
                                                  value = Math.round(value);
                                                  value /= 100;
                                                } else {
                                                  value = 0.0;
                                                }
                                                setValue(
                                                  "category-bonus-" +
                                                    category.id,
                                                  value
                                                );
                                                handleCatBtn(
                                                  "bonus",
                                                  category.originalTitle,
                                                  value
                                                );
                                              }
                                            }}
                                            optionValue={
                                              valueList &&
                                              valueList[
                                                category.originalTitle
                                              ] &&
                                              valueList[
                                                category.originalTitle
                                              ].bonusValues.map(
                                                (bonusValue, index) => {
                                                  return (
                                                    <option
                                                      className="bonusComm-option-value"
                                                      value={
                                                        bonusValue !== "-"
                                                          ? parseFloat(
                                                              bonusValue.toFixed(
                                                                2
                                                              )
                                                            )
                                                          : "-"
                                                      }
                                                    >
                                                      {bonusValue !== "-"
                                                        ? bonusValue.toFixed(2)
                                                        : "-"}
                                                    </option>
                                                  );
                                                }
                                              )
                                            }
                                            value={value}
                                            category={category}
                                            handleSelectCatValue={
                                              handleSelectCatValue
                                            }
                                            errors={errors}
                                            type="bonus" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                            section="referral"
                                          />

                                          <PlusMinusMaxButton
                                            buttonSection="max"
                                            text={t("MAX")}
                                            styleValueButton={getValues('bonus-' + product.productId) == product.maxBonus}
                                            category={category}
                                            onClickMax={() =>
                                              handleMaxCatBtn(
                                                category.id,
                                                category.originalTitle,
                                                "bonus"
                                              )
                                            }
                                            section="referral"
                                          />
                                        </>
                                      );
                                    }}
                                  />
                                </div>
                              )}
                              {(products.filter(
                                (x) =>
                                  x.categoryName === category.originalTitle &&
                                  x.maxCommission > 0
                              ).length > 0 ||
                                category.originalTitle === "All") && (
                                <div className="referral-edit-details mb-3">
                                  <Controller
                                    control={control}
                                    name={"category-commission-" + category.id}
                                    defaultValue={0}
                                    render={({ onChange, value }) => {
                                      let valueNotLowest =
                                        checkValueForLowest(value);
                                      let valueNotHighest =
                                        checkValueForHighest(
                                          value,
                                          category,
                                          "commission"
                                        );

                                        if(document.getElementById("category-" + category.id + "-commission") !== null) {
                                          if (!valueNotHighest) {
                                            document.getElementById("category-" + category.id + "-commission").style.background = backgroundDarkMaxButton;
                                          }
                                          else {
                                            document.getElementById("category-" + category.id + "-commission").style.background = backgroundLightMaxButton;
                                          }
                                        }
                                      return (
                                        <>
                                          <div className="first font-12">
                                            {t("COMMISSION_SHORT")}
                                            <br />
                                            {t("MAX") + " : "}
                                            {valueList &&
                                            valueList[category.originalTitle]
                                              ? valueList[
                                                  category.originalTitle
                                                ].highestMaxComm.toFixed(2)
                                              : "0"}
                                            %
                                          </div>

                                          <PlusMinusMaxButton
                                            buttonSection="plusminus"
                                            styleValueMinus={valueNotLowest}
                                            onClickMinus={(e) => {
                                              if (valueNotLowest === true) {
                                                if (value !== "-") {
                                                  value -= 0.1;
                                                  value *= 100;
                                                  value = Math.round(value);
                                                  value /= 100;
                                                } else {
                                                  value = 0.0;
                                                }
                                                setValue(
                                                  "category-commission-" +
                                                    category.id,
                                                  parseFloat(value.toFixed(2))
                                                );
                                                handleCatBtn(
                                                  "commission",
                                                  category.id,
                                                  category.originalTitle,
                                                  value
                                                );
                                              }
                                            }}
                                            styleValuePlus={valueNotHighest}
                                            onClickPlus={(e) => {
                                              if (valueNotHighest === true) {
                                                if (value !== "-") {
                                                  value += 0.1;
                                                  value *= 100;
                                                  value = Math.round(value);
                                                  value /= 100;
                                                } else {
                                                  value = 0.0;
                                                }
                                                setValue(
                                                  "category-commission-" +
                                                    category.id,
                                                  parseFloat(value.toFixed(2))
                                                );
                                                handleCatBtn(
                                                  "commission",
                                                  category.id,
                                                  category.originalTitle,
                                                  value
                                                );
                                              }
                                            }}
                                            optionValue={
                                              valueList &&
                                              valueList[
                                                category.originalTitle
                                              ] &&
                                              valueList[
                                                category.originalTitle
                                              ].commValues.map(
                                                (commValue, index) => {
                                                  return (
                                                    <option
                                                      className="bonusComm-option-value"
                                                      value={
                                                        commValue !== "-"
                                                          ? parseFloat(
                                                              commValue.toFixed(
                                                                2
                                                              )
                                                            )
                                                          : "-"
                                                      }
                                                    >
                                                      {commValue !== "-"
                                                        ? commValue.toFixed(2)
                                                        : "-"}
                                                    </option>
                                                  );
                                                }
                                              )
                                            }
                                            value={value}
                                            category={category}
                                            handleSelectCatValue={
                                              handleSelectCatValue
                                            }
                                            product={product}
                                            errors={errors}
                                            type="commission" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                            section="referral"
                                          />

                                          <PlusMinusMaxButton
                                            buttonSection="max"
                                            id={"category-" + category.id + "-commission"}
                                            text={t("MAX")}
                                            onClickMax={() =>
                                              handleMaxCatBtn(
                                                category.id,
                                                category.originalTitle,
                                                "commission"
                                              )
                                            }
                                            section="referral"
                                          />
                                        </>
                                      );
                                    }}
                                  />
                                </div>
                              )}
                              {category.originalTitle === "Poker" &&
                                (products.filter(
                                  (x) =>
                                    x.categoryName === category.originalTitle &&
                                    x.maxClubFee > 0
                                ).length > 0 ||
                                  category.originalTitle === "All") && (
                                  <div className="referral-edit-details mb-3">
                                    <Controller
                                      control={control}
                                      name={"category-clubFee-" + category.id}
                                      defaultValue={0}
                                      render={({ onChange, value }) => {
                                        let valueNotLowest =
                                          checkValueForLowest(value);
                                        let valueNotHighest =
                                          checkValueForHighest(
                                            value,
                                            category,
                                            "clubFee"
                                          );
                                          if(document.getElementById("category-" + category.id + "-clubFee") !== null) {
                                            if (!valueNotHighest) {
                                              document.getElementById("category-" + category.id + "-clubFee").style.background = backgroundDarkMaxButton;
                                            }
                                            else {
                                              document.getElementById("category-" + category.id + "-clubFee").style.background = backgroundLightMaxButton;
                                            }
                                          }
                                        return (
                                          <>
                                            <div className="first font-12">
                                              {t("CLUB_FEE")}
                                              <br />
                                              {t("MAX") + " : "}
                                              {valueList &&
                                              valueList[category.originalTitle]
                                                ? valueList[
                                                    category.originalTitle
                                                  ].highestMaxClubFee.toFixed(2)
                                                : "0"}
                                              %
                                            </div>

                                            <PlusMinusMaxButton
                                              buttonSection="plusminus"
                                              styleValueMinus={valueNotLowest}
                                              onClickMinus={(e) => {
                                                if (valueNotLowest === true) {
                                                  if (value !== "-") {
                                                    value -= 5.0;
                                                    value *= 100;
                                                    value = Math.round(value);
                                                    value /= 100;
                                                  } else {
                                                    value = 0.0;
                                                  }
                                                  setValue(
                                                    "category-clubFee-" +
                                                      category.id,
                                                    parseFloat(value.toFixed(2))
                                                  );
                                                  handleCatBtn(
                                                    "clubFee",
                                                      category.id,
                                                      category.originalTitle,
                                                      value
                                                  );
                                                }
                                              }}
                                              styleValuePlus={valueNotHighest}
                                              onClickPlus={(e) => {
                                                if (valueNotHighest === true) {
                                                  if (value !== "-") {
                                                    value += 5.0;
                                                    value *= 100;
                                                    value = Math.round(value);
                                                    value /= 100;
                                                  } else {
                                                    value = 0.0;
                                                  }
                                                  setValue(
                                                    "category-clubFee-" +
                                                      category.id,
                                                    parseFloat(value.toFixed(2))
                                                  );
                                                  handleCatBtn(
                                                    "clubFee",
                                                      category.id,
                                                      category.originalTitle,
                                                      value
                                                  );
                                                }
                                              }}
                                              optionValue={
                                                valueList &&
                                                valueList[
                                                  category.originalTitle
                                                ] &&
                                                valueList[
                                                  category.originalTitle
                                                ].clubFeeValues.map(
                                                  (clubFeeValue, index) => {
                                                    return (
                                                      <option
                                                        className="bonusComm-option-value"
                                                        value={
                                                          clubFeeValue !== "-"
                                                            ? parseFloat(
                                                                clubFeeValue.toFixed(
                                                                  2
                                                                )
                                                              )
                                                            : "-"
                                                        }
                                                      >
                                                        {clubFeeValue !== "-"
                                                          ? clubFeeValue.toFixed(
                                                              2
                                                            )
                                                          : "-"}
                                                      </option>
                                                    );
                                                  }
                                                )
                                              }
                                              value={value}
                                              category={category}
                                              handleSelectCatValue={
                                                handleSelectCatValue
                                              }
                                              errors={errors}
                                              type="clubFee" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                              section="referral"
                                            />
                                            
                                            <PlusMinusMaxButton
                                              buttonSection="max"
                                              text={t("MAX")}
                                              id={"category-" + category.id + "-clubFee"}
                                              onClickMax={() =>
                                                handleMaxCatBtn(
                                                  category.id,
                                                  category.originalTitle,
                                                  "clubFee"
                                                )
                                              }
                                              section="referral"
                                            />

                                          </>
                                        );
                                      }}
                                    />
                                  </div>
                                )}
                            </div>
                          </div>

                          {/*foreach product in category*/}

                          {products.filter(
                            (x) => x.categoryName === category.originalTitle
                          ).length > 0 &&
                            products
                              .filter(
                                (product) =>
                                  product.categoryName ===
                                    category.originalTitle &&
                                  (product.maxBonus > 0 ||
                                    product.maxCommission > 0 ||
                                    product.maxClubFee > 0)
                              )
                              .map((product, i) => {
                                return (
                                  <div className="referral-edit-box font-14 mt-2">
                                    <div>
                                      <h6>{product.productName}</h6>
                                    </div>
                                    <div className="font-14">
                                      {product.maxBonus > 0 && (
                                        <div className="referral-edit-details mb-3">
                                          <Controller
                                            control={control}
                                            name={"bonus-" + product.productId}
                                            defaultValue={0}
                                            render={({ onChange, value }) => {
                                              return (
                                                <>
                                                  <div className="first font-12">
                                                    {t("BONUS")}
                                                    <br />
                                                    {t("MAX") + " : "}
                                                    {product.maxBonus.toFixed(
                                                      2
                                                    )}
                                                    %
                                                  </div>

                                                  <PlusMinusMaxButton
                                                    buttonSection="plusminus"
                                                    styleValueMinus={
                                                      product.maxBonus > 0 &&
                                                      (value !== "-"
                                                        ? parseFloat(
                                                            value.toFixed(2)
                                                          ) > 0
                                                        : true)
                                                    }
                                                    onClickMinus={(e) => {
                                                      if (value !== "-") {
                                                        if (
                                                          product.maxBonus >
                                                            0 &&
                                                          parseFloat(value) > 0
                                                        ) {
                                                          value -= 0.1;
                                                          value *= 100;
                                                          value =
                                                            Math.round(value);
                                                          value /= 100;
                                                        }
                                                      } else {
                                                        value = 0.0;
                                                      }
                                                      setValue(
                                                        "bonus-" +
                                                          product.productId,
                                                        value
                                                      );
                                                    }}
                                                    styleValuePlus={
                                                      product.maxBonus > 0 &&
                                                      (value !== "-"
                                                        ? parseFloat(
                                                            value.toFixed(2)
                                                          ) < product.maxBonus
                                                        : true)
                                                    }
                                                    onClickPlus={(e) => {
                                                      if (value !== "-") {
                                                        if (
                                                          product.maxBonus >
                                                            0 &&
                                                          parseFloat(value) <
                                                            product.maxBonus
                                                        ) {
                                                          value += 0.1;
                                                          value *= 100;
                                                          value =
                                                            Math.round(value);
                                                          value /= 100;
                                                        }
                                                      } else {
                                                        value = 0.0;
                                                      }
                                                      setValue(
                                                        "bonus-" +
                                                          product.productId,
                                                        value
                                                      );
                                                    }}
                                                    optionValue={
                                                      valueList &&
                                                      valueList[
                                                        category.originalTitle
                                                      ] &&
                                                      valueList[
                                                        category.originalTitle
                                                      ][product.productName] &&
                                                      valueList[
                                                        category.originalTitle
                                                      ][
                                                        product.productName
                                                      ].bonusValues.map(
                                                        (bonusValue, index) => {
                                                          return (
                                                            <option
                                                              className="bonusComm-option-value"
                                                              value={
                                                                bonusValue !==
                                                                "-"
                                                                  ? parseFloat(
                                                                      bonusValue.toFixed(
                                                                        2
                                                                      )
                                                                    )
                                                                  : "-"
                                                              }
                                                            >
                                                              {bonusValue !==
                                                              "-"
                                                                ? bonusValue.toFixed(
                                                                    2
                                                                  )
                                                                : "-"}
                                                            </option>
                                                          );
                                                        }
                                                      )
                                                    }
                                                    value={value}
                                                    category={category}
                                                    product={product}
                                                    handleSelectCatValue={
                                                      handleSelectCatValue
                                                    }
                                                    handleSelectValue={
                                                      handleSelectValue
                                                    }
                                                    errors={errors}
                                                    type="maxBonus" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                                    section="referral"
                                                      />
                                                     
                                                  <PlusMinusMaxButton
                                                    buttonSection="max"
                                                    text={t("MAX")}
                                                    styleValueButton={getValues('bonus-' + product.productId) == product.maxBonus}
                                                    category={category}
                                                    onClickMax={() =>
                                                      handleMaxBtn(
                                                        product.productId,
                                                        product.maxBonus,
                                                        product.maxCommission,
                                                        product.maxClubFee,
                                                        "bonus"
                                                      )
                                                    }
                                                    section="referral"
                                                  />
                                                </>
                                              );
                                            }}
                                          />
                                        </div>
                                      )}
                                      {product.maxCommission > 0 && (
                                        <div className="referral-edit-details mb-3">
                                          <Controller
                                            control={control}
                                            name={
                                              "commission-" + product.productId
                                            }
                                            defaultValue={0}
                                            render={({ onChange, value }) => {
                                              if(value === product.maxCommission){
                                                if(document.getElementById("product-" + product.productId + "-commission") !== null) {
                                                    document.getElementById("product-" + product.productId + "-commission").style.background = backgroundDarkMaxButton;
                                                }
                                              }
                                              else {
                                                if(document.getElementById("product-" + product.productId + "-commission") !== null) {
                                                  document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                }
                                              }
                                              return (
                                                <>
                                                  <div className="first font-12">
                                                    {t("COMMISSION_SHORT")}
                                                    <br />
                                                    {t("MAX") + " : "}
                                                    {product.maxCommission.toFixed(
                                                      2
                                                    )}
                                                    %
                                                  </div>

                                                  <PlusMinusMaxButton
                                                      category={category}
                                                      styleValueMinus={
                                                        product.maxCommission >
                                                          0 &&
                                                        (value !== "-"
                                                          ? parseFloat(
                                                              value.toFixed(2)
                                                            ) > 0
                                                          : true)
                                                      }
                                                      onClickMinus={(e) => {
                                                        if (value !== "-") {
                                                          if (
                                                            product.maxCommission >
                                                              0 &&
                                                            parseFloat(value) >
                                                              0
                                                          ) {
                                                            value -= 0.1;
                                                            value *= 100;
                                                            value =
                                                              Math.round(value);
                                                            value /= 100;

                                                            document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                          }
                                                          else if(value == product.maxCommission) {
                                                            document.getElementById("product-" + product.productId + "-commission").style.background = backgroundDarkMaxButton;
                                                          }
                                                        } 
                                                        else {
                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                          value = 0.0;
                                                        }
                                                        
                                                        setValue(
                                                          "commission-" +
                                                            product.productId,
                                                          value
                                                        );
                                                      }}
                                                      styleValuePlus={
                                                        product.maxCommission >
                                                          0 &&
                                                        (value !== "-"
                                                          ? parseFloat(
                                                              value.toFixed(2)
                                                            ) <
                                                            product.maxCommission
                                                          : true)
                                                      }

                                                      onClickPlus={(e) => {
                                                        if (value !== "-") {
                                                        if (
                                                          product.maxCommission >
                                                            0 &&
                                                          parseFloat(value) <
                                                            product.maxCommission
                                                        ) {
                                                          value += 0.1;
                                                          value *= 100;
                                                          value =
                                                            Math.round(value);
                                                          value /= 100;

                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                        }

                                                        if(value == product.maxCommission) {
                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundDarkMaxButton;
                                                        }
                                                        else {
                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                        }
                                                      }
                                                      else {
                                                        document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                        value = 0.0;
                                                      }
                                                        setValue(
                                                          "commission-" +
                                                            product.productId,
                                                          value
                                                        );
                                                      }}
                                                      buttonSection="plusminus"
                                                      optionValue={valueList[
                                                        category.originalTitle
                                                      ][
                                                        product.productName
                                                      ].commValues.map(
                                                        (commValue, index) => {
                                                          return (
                                                            <option
                                                              key={
                                                                "dg_comm_values_" +
                                                                index
                                                              }
                                                              className="bonusComm-option-value"
                                                              value={
                                                                commValue !==
                                                                "-"
                                                                  ? parseFloat(
                                                                      commValue.toFixed(
                                                                        2
                                                                      )
                                                                    )
                                                                  : "-"
                                                              }
                                                            >
                                                              {commValue !== "-"
                                                                ? commValue.toFixed(
                                                                    2
                                                                  )
                                                                : "-"}
                                                            </option>
                                                          );
                                                        }
                                                      )}
                                                      product={product}
                                                      value={value}
                                                      handleSelectValue={
                                                        handleSelectValue
                                                      }
                                                      errors={errors}
                                                      type="maxCommission" // type for bonus/commission/clubfee/maxBonus/maxCommission/maxClubfee
                                                      section="referral"
                                                    />
                                                     
                                                    <PlusMinusMaxButton
                                                      buttonSection="max"
                                                      text={t("MAX")}
                                                      id={'product-' + product.productId + '-commission'}
                                                      onClickMax={() =>
                                                        handleMaxBtn(
                                                          product.productId,
                                                          product.maxBonus,
                                                          product.maxCommission,
                                                          product.maxClubFee,
                                                          "commission"
                                                        )
                                                      }
                                                      section="referral"
                                                    />
                                                </>
                                              );
                                            }}
                                          />
                                        </div>
                                      )}
                                      {product.productName === "D2 Poker" &&
                                        product.maxClubFee > 0 && (
                                          <div className="referral-edit-details mb-3">
                                            <Controller
                                              control={control}
                                              name={
                                                "clubFee-" + product.productId
                                              }
                                              defaultValue={0}
                                              render={({ onChange, value }) => {
                                                if(value === product.maxClubFee){
                                                  if(document.getElementById("product-" + product.productId + "-clubFee") !== null) {
                                                      document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundDarkMaxButton;
                                                  }
                                                }
                                                else {
                                                  if(document.getElementById("product-" + product.productId + "-clubFee") !== null) {
                                                    document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundLightMaxButton;
                                                  }
                                                }
                                                
                                                return (
                                                  <>
                                                    <div className="first font-12">
                                                      {t("CLUB_FEE")}
                                                      <br />
                                                      {t("MAX") + " : "}
                                                      {product.maxClubFee.toFixed(
                                                        2
                                                      )}
                                                      %
                                                    </div>

                                                    <PlusMinusMaxButton
                                                      buttonSection="plusminus"
                                                      styleValueMinus={
                                                        product.maxClubFee >
                                                          0 &&
                                                        (value !== "-"
                                                          ? parseFloat(
                                                              value.toFixed(2)
                                                            ) > 0
                                                          : true)
                                                      }
                                                      onClickMinus={(e) => {
                                                        if (value !== "-") {
                                                          if (
                                                            product.maxClubFee >
                                                              0 &&
                                                            parseFloat(value) >
                                                              0
                                                          ) {
                                                            value -= 5.0;
                                                            value *= 100;
                                                            value =
                                                              Math.round(value);
                                                            value /= 100;

                                                            document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundDarkMaxButton;
                                                          }
                                                          else if(value == product.maxClubFee) {
                                                            document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundDarkMaxButton;
                                                          }
                                                        } else {
                                                          value = 0.0;
                                                          document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundLightMaxButton;
                                                        }
                                                        setValue(
                                                          "clubFee-" +
                                                            product.productId,
                                                          value
                                                        );
                                                      }}
                                                      styleValuePlus={
                                                        product.maxClubFee >
                                                          0 &&
                                                        (value !== "-"
                                                          ? parseFloat(
                                                              value.toFixed(2)
                                                            ) <
                                                            product.maxClubFee
                                                          : true)
                                                      }
                                                      onClickPlus={(e) => {
                                                        if (value !== "-") {
                                                          if (
                                                            product.maxClubFee >
                                                              0 &&
                                                            parseFloat(value) <
                                                              product.maxClubFee
                                                          ) {
                                                            value += 5.0;
                                                            value *= 100;
                                                            value =
                                                              Math.round(value);
                                                            value /= 100;
                                                            document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundDarkMaxButton;
                                                          }
                                                          else if(value == product.maxClubFee) {
                                                            document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundDarkMaxButton;
                                                          }
                                                        } else {
                                                          document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundLightMaxButton;
                                                          value = 0.0;
                                                        }
                                                        setValue(
                                                          "clubFee-" +
                                                            product.productId,
                                                          value
                                                        );
                                                      }}
                                                      optionValue={
                                                        valueList &&
                                                        valueList[
                                                          category.originalTitle
                                                        ] &&
                                                        valueList[
                                                          category.originalTitle
                                                        ][
                                                          product.productName
                                                        ] &&
                                                        valueList[
                                                          category.originalTitle
                                                        ][
                                                          product.productName
                                                        ].clubFeeValues.map(
                                                          (
                                                            clubFeeValue,
                                                            index
                                                          ) => {
                                                            return (
                                                              <option
                                                                className="bonusComm-option-value"
                                                                value={
                                                                  clubFeeValue !==
                                                                  "-"
                                                                    ? parseFloat(
                                                                        clubFeeValue.toFixed(
                                                                          2
                                                                        )
                                                                      )
                                                                    : "-"
                                                                }
                                                              >
                                                                {clubFeeValue !==
                                                                "-"
                                                                  ? clubFeeValue.toFixed(
                                                                      2
                                                                    )
                                                                  : "-"}
                                                              </option>
                                                            );
                                                          }
                                                        )
                                                      }
                                                      value={value}
                                                      category={category}
                                                      product={product}
                                                      // handleSelectCatValue={
                                                      //   handleSelectCatValue
                                                      // }
                                                      id={"div-product-" + product.productId + "-clubFee"}
                                                      handleSelectValue={
                                                        handleSelectValue
                                                      }
                                                      errors={errors}
                                                      type="maxClubFee" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                                      section="referral"
                                                    />

                                                    <PlusMinusMaxButton
                                                      buttonSection="max"
                                                      text={t("MAX")}
                                                      id={'product-' + product.productId + '-clubFee'}
                                                      onClickMax={() =>
                                                        handleMaxBtn(
                                                          product.productId,
                                                          product.maxBonus,
                                                          product.maxCommission,
                                                          product.maxClubFee,
                                                          "clubFee"
                                                        )
                                                      }
                                                      section="referral"
                                                    />
                                                  </>
                                                );
                                              }}
                                            />
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                );
                              })}
                        </div>
                      </TabPane>
                    );
                  }
                })}

              {/* this loop is to handle when active category is "All" */}
              {categories &&
                categories.length > 0 &&
                activeTab ===
                  categories.find((x) => x.originalTitle === "All").id && (
                  <TabPane
                    tabId={categories.find((x) => x.originalTitle === "All").id}
                  >
                    {map(
                      categories.filter((x) => x.originalTitle !== "All"),
                      (category, index) => {
                        return (
                          <>
                            <div
                              className={
                                "text-white " + (index !== 0 ? "mt-5" : "mt-4")
                              }
                            >
                              <div className="referral-edit-box font-14 mt-2">
                                <div>
                                  <h6 className="text-gold">
                                    {t(category.originalTitle)}
                                  </h6>
                                </div>
                                <div className="font-14">
                                  {(products.filter(
                                    (x) =>
                                      x.categoryName ===
                                        category.originalTitle && x.maxBonus > 0
                                  ).length > 0 ||
                                    category.originalTitle === "All") && (
                                    <div className="referral-edit-details mb-3">
                                      <Controller
                                        control={control}
                                        name={"category-bonus-" + category.id}
                                        defaultValue={0}
                                        render={({ onChange, value }) => {
                                          let valueNotLowest =
                                            checkValueForLowest(value);
                                          let valueNotHighest =
                                            checkValueForHighest(
                                              value,
                                              category,
                                              "bonus"
                                            );
                                          return (
                                            <>
                                              <div className="first font-12">
                                                {t("BONUS")}
                                                <br />
                                                {t("MAX") + " : "}
                                                {valueList &&
                                                valueList[
                                                  category.originalTitle
                                                ]
                                                  ? valueList[
                                                      category.originalTitle
                                                    ].highestMaxBonus.toFixed(2)
                                                  : "0"}
                                                %
                                              </div>

                                              <PlusMinusMaxButton
                                                buttonSection="plusminus"
                                                styleValueMinus={valueNotLowest}
                                                onClickMinus={(e) => {
                                                  if (valueNotLowest === true) {
                                                    if (value !== "-") {
                                                      value -= 0.1;
                                                      value *= 100;
                                                      value = Math.round(value);
                                                      value /= 100;
                                                    } else {
                                                      value = 0.0;
                                                    }
                                                    setValue(
                                                      "category-bonus-" +
                                                        category.id,
                                                      value
                                                    );
                                                    handleCatBtn(
                                                      "bonus",
                                                      category.originalTitle,
                                                      value
                                                    );
                                                  }
                                                }}
                                                styleValuePlus={valueNotHighest}
                                                onClickPlus={(e) => {
                                                  if (
                                                    valueNotHighest === true
                                                  ) {
                                                    if (value !== "-") {
                                                      value += 0.1;
                                                      value *= 100;
                                                      value = Math.round(value);
                                                      value /= 100;
                                                    } else {
                                                      value = 0.0;
                                                    }
                                                    setValue(
                                                      "category-bonus-" +
                                                        category.id,
                                                      value
                                                    );
                                                    handleCatBtn(
                                                      "bonus",
                                                      category.originalTitle,
                                                      value
                                                    );
                                                  }
                                                }}
                                                optionValue={
                                                  valueList &&
                                                  valueList[
                                                    category.originalTitle
                                                  ] &&
                                                  valueList[
                                                    category.originalTitle
                                                  ].bonusValues.map(
                                                    (bonusValue, index) => {
                                                      return (
                                                        <option
                                                          className="bonusComm-option-value"
                                                          value={
                                                            bonusValue !== "-"
                                                              ? parseFloat(
                                                                  bonusValue.toFixed(
                                                                    2
                                                                  )
                                                                )
                                                              : "-"
                                                          }
                                                        >
                                                          {bonusValue !== "-"
                                                            ? bonusValue.toFixed(
                                                                2
                                                              )
                                                            : "-"}
                                                        </option>
                                                      );
                                                    }
                                                  )
                                                }
                                                value={value}
                                                category={category}
                                                handleSelectCatValue={
                                                  handleSelectCatValue
                                                }
                                                errors={errors}
                                                type="bonus" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                                section="referral"
                                              />

                                              <PlusMinusMaxButton
                                                buttonSection="max"
                                                text={t("MAX")}
                                                styleValueButton={getValues('bonus-' + product.productId) == product.maxBonus}
                                                category={category}
                                                onClickMax={() =>
                                                  handleMaxCatBtn(
                                                    category.id,
                                                    category.originalTitle,
                                                    "bonus"
                                                  )
                                                }
                                                section="referral"
                                              />
                                            </>
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                  {(products.filter(
                                    (x) =>
                                      x.categoryName ===
                                        category.originalTitle &&
                                      x.maxCommission > 0
                                  ).length > 0 ||
                                    category.originalTitle === "All") && (
                                    <div className="referral-edit-details mb-3">
                                      <Controller
                                        control={control}
                                        name={
                                          "category-commission-" + category.id
                                        }
                                        defaultValue={0}
                                        render={({ onChange, value }) => {
                                          let valueNotLowest =
                                            checkValueForLowest(value);
                                          let valueNotHighest =
                                            checkValueForHighest(
                                              value,
                                              category,
                                              "commission"
                                            );

                                            if(document.getElementById("category-" + category.id + "-commission") !== null) {
                                              if (!valueNotHighest) {
                                                document.getElementById("category-" + category.id + "-commission").style.background = backgroundDarkMaxButton;
                                              }
                                              else {
                                                document.getElementById("category-" + category.id + "-commission").style.background = backgroundLightMaxButton;
                                              }
                                            }
                                          return (
                                            <>
                                              <div className="first font-12">
                                                {t("COMMISSION_SHORT")}
                                                <br />
                                                {t("MAX") + " : "}
                                                {valueList &&
                                                valueList[
                                                  category.originalTitle
                                                ]
                                                  ? valueList[
                                                      category.originalTitle
                                                    ].highestMaxComm.toFixed(2)
                                                  : "0"}
                                                %
                                              </div>

                                              <PlusMinusMaxButton
                                            buttonSection="plusminus"
                                            styleValueMinus={valueNotLowest}
                                            onClickMinus={(e) => {
                                              if (valueNotLowest === true) {
                                                if (value !== "-") {
                                                  value -= 0.1;
                                                  value *= 100;
                                                  value = Math.round(value);
                                                  value /= 100;
                                                } else {
                                                  value = 0.0;
                                                }
                                                setValue(
                                                  "category-commission-" +
                                                    category.id,
                                                  parseFloat(value.toFixed(2))
                                                );
                                                handleCatBtn(
                                                  "commission",
                                                  category.id,
                                                  category.originalTitle,
                                                  value
                                                );
                                              }
                                            }}
                                            styleValuePlus={valueNotHighest}
                                            onClickPlus={(e) => {
                                              if (valueNotHighest === true) {
                                                if (value !== "-") {
                                                  value += 0.1;
                                                  value *= 100;
                                                  value = Math.round(value);
                                                  value /= 100;
                                                } else {
                                                  value = 0.0;
                                                }
                                                setValue(
                                                  "category-commission-" +
                                                    category.id,
                                                  parseFloat(value.toFixed(2))
                                                );
                                                handleCatBtn(
                                                  "commission",
                                                  category.id,
                                                  category.originalTitle,
                                                  value
                                                );
                                              }
                                            }}
                                            optionValue={
                                              valueList &&
                                              valueList[
                                                category.originalTitle
                                              ] &&
                                              valueList[
                                                category.originalTitle
                                              ].commValues.map(
                                                (commValue, index) => {
                                                  return (
                                                    <option
                                                      className="bonusComm-option-value"
                                                      value={
                                                        commValue !== "-"
                                                          ? parseFloat(
                                                              commValue.toFixed(
                                                                2
                                                              )
                                                            )
                                                          : "-"
                                                      }
                                                    >
                                                      {commValue !== "-"
                                                        ? commValue.toFixed(2)
                                                        : "-"}
                                                    </option>
                                                  );
                                                }
                                              )
                                            }
                                            value={value}
                                            category={category}
                                            handleSelectCatValue={
                                              handleSelectCatValue
                                            }
                                            product={product}
                                            errors={errors}
                                            type="commission" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                            section="referral"
                                          />

                                              <PlusMinusMaxButton
                                                buttonSection="max"
                                                id={"category-" + category.id + "-commission"}
                                                text={t("MAX")}
                                                onClickMax={() =>
                                                  handleMaxCatBtn(
                                                    category.id,
                                                    category.originalTitle,
                                                    "commission"
                                                  )
                                                }
                                                section="referral"
                                              />
                                            </>
                                          );
                                        }}
                                      />
                                    </div>
                                  )}
                                  {category.originalTitle === "Poker" &&
                                    (products.filter(
                                      (x) =>
                                        x.categoryName ===
                                          category.originalTitle &&
                                        x.maxClubFee > 0
                                    ).length > 0 ||
                                      category.originalTitle === "All") && (
                                      <div className="referral-edit-details mb-3">
                                        <Controller
                                          control={control}
                                          name={
                                            "category-clubFee-" + category.id
                                          }
                                          defaultValue={0}
                                          render={({ onChange, value }) => {
                                            let valueNotLowest =
                                              checkValueForLowest(value);
                                            let valueNotHighest =
                                              checkValueForHighest(
                                                value,
                                                category,
                                                "clubFee"
                                              );

                                              if(document.getElementById("category-" + category.id + "-clubFee") !== null) {
                                                if (!valueNotHighest) {
                                                  document.getElementById("category-" + category.id + "-clubFee").style.background = backgroundDarkMaxButton;
                                                }
                                                else {
                                                  document.getElementById("category-" + category.id + "-clubFee").style.background = backgroundLightMaxButton;
                                                }
                                              }
                                            return (
                                              <>
                                                <div className="first font-12">
                                                  {t("CLUB_FEE")}
                                                  <br />
                                                  {t("MAX") + " : "}
                                                  {valueList &&
                                                  valueList[
                                                    category.originalTitle
                                                  ]
                                                    ? valueList[
                                                        category.originalTitle
                                                      ].highestMaxClubFee.toFixed(
                                                        2
                                                      )
                                                    : "0"}
                                                  %
                                                </div>

                                                <PlusMinusMaxButton
                                                  buttonSection="plusminus"
                                                  styleValueMinus={
                                                    valueNotLowest
                                                  }
                                                  onClickMinus={(e) => {
                                                    if (
                                                      valueNotLowest === true
                                                    ) {
                                                      if (value !== "-") {
                                                        value -= 5.0;
                                                        value *= 100;
                                                        value =
                                                          Math.round(value);
                                                        value /= 100;
                                                      } else {
                                                        value = 0.0;
                                                      }
                                                      setValue(
                                                        "category-clubFee-" +
                                                          category.id,
                                                        parseFloat(
                                                          value.toFixed(2)
                                                        )
                                                      );
                                                      handleCatBtn(
                                                        "clubFee",
                                                        category.id,
                                                        category.originalTitle,
                                                        value
                                                      );
                                                    }
                                                  }}
                                                  styleValuePlus={
                                                    valueNotHighest
                                                  }
                                                  onClickPlus={(e) => {
                                                    if (
                                                      valueNotHighest === true
                                                    ) {
                                                      if (value !== "-") {
                                                        value += 5.0;
                                                        value *= 100;
                                                        value =
                                                          Math.round(value);
                                                        value /= 100;
                                                      } else {
                                                        value = 0.0;
                                                      }
                                                      setValue(
                                                        "category-clubFee-" +
                                                          category.id,
                                                        parseFloat(
                                                          value.toFixed(2)
                                                        )
                                                      );
                                                      handleCatBtn(
                                                        "clubFee",
                                                        category.id,
                                                        category.originalTitle,
                                                        value
                                                      );
                                                    }
                                                  }}
                                                  optionValue={
                                                    valueList &&
                                                    valueList[
                                                      category.originalTitle
                                                    ] &&
                                                    valueList[
                                                      category.originalTitle
                                                    ].clubFeeValues.map(
                                                      (clubFeeValue, index) => {
                                                        return (
                                                          <option
                                                            className="bonusComm-option-value"
                                                            value={
                                                              clubFeeValue !==
                                                              "-"
                                                                ? parseFloat(
                                                                    clubFeeValue.toFixed(
                                                                      2
                                                                    )
                                                                  )
                                                                : "-"
                                                            }
                                                          >
                                                            {clubFeeValue !==
                                                            "-"
                                                              ? clubFeeValue.toFixed(
                                                                  2
                                                                )
                                                              : "-"}
                                                          </option>
                                                        );
                                                      }
                                                    )
                                                  }
                                                  value={value}
                                                  category={category}
                                                  handleSelectCatValue={
                                                    handleSelectCatValue
                                                  }
                                                  errors={errors}
                                                  type="clubfee" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                                  section="referral"
                                                />

                                                <PlusMinusMaxButton
                                                  buttonSection="max"
                                                  text={t("MAX")}
                                                  id={"category-" + category.id + "-clubFee"}
                                                  onClickMax={() =>
                                                    handleMaxCatBtn(
                                                      category.id,
                                                      category.originalTitle,
                                                      "clubFee"
                                                    )
                                                  }
                                                  section="referral"
                                                />
                                              </>
                                            );
                                          }}
                                        />
                                      </div>
                                    )}
                                </div>
                              </div>

                              {products.filter(
                                (x) => x.categoryName === category.originalTitle
                              ).length > 0 &&
                                products
                                  .filter(
                                    (product) =>
                                      product.categoryName ===
                                        category.originalTitle &&
                                      (product.maxBonus > 0 ||
                                        product.maxCommission > 0 ||
                                        product.maxClubFee > 0)
                                  )
                                  .map((product, i) => {
                                    return (
                                      <div className="referral-edit-box font-14 mt-2">
                                        <div>
                                          <h6>{product.productName}</h6>
                                        </div>
                                        <div className="font-14">
                                          {product.maxBonus > 0 && (
                                            <div className="referral-edit-details mb-3">
                                              <Controller
                                                control={control}
                                                name={
                                                  "bonus-" + product.productId
                                                }
                                                defaultValue={0}
                                                render={({
                                                  onChange,
                                                  value,
                                                }) => {
                                                  return (
                                                    <>
                                                      <div className="first font-12">
                                                        {t("BONUS")}
                                                        <br />
                                                        {t("MAX") + " : "}
                                                        {product.maxBonus.toFixed(
                                                          2
                                                        )}
                                                        %
                                                      </div>

                                                      <PlusMinusMaxButton
                                                        buttonSection="plusminus"
                                                        styleValueMinus={
                                                          product.maxBonus >
                                                            0 &&
                                                          (value !== "-"
                                                            ? parseFloat(
                                                                value.toFixed(2)
                                                              ) > 0
                                                            : true)
                                                        }
                                                        onClickMinus={(e) => {
                                                          if (value !== "-") {
                                                            if (
                                                              product.maxBonus >
                                                                0 &&
                                                              parseFloat(
                                                                value
                                                              ) > 0
                                                            ) {
                                                              value -= 0.1;
                                                              value *= 100;
                                                              value =
                                                                Math.round(
                                                                  value
                                                                );
                                                              value /= 100;
                                                            }
                                                          } else {
                                                            value = 0.0;
                                                          }
                                                          setValue(
                                                            "bonus-" +
                                                              product.productId,
                                                            value
                                                          );
                                                        }}
                                                        styleValuePlus={
                                                          product.maxBonus >
                                                            0 &&
                                                          (value !== "-"
                                                            ? parseFloat(
                                                                value.toFixed(2)
                                                              ) <
                                                              product.maxBonus
                                                            : true)
                                                        }
                                                        onClickPlus={(e) => {
                                                          if (value !== "-") {
                                                            if (
                                                              product.maxBonus >
                                                                0 &&
                                                              parseFloat(
                                                                value
                                                              ) <
                                                                product.maxBonus
                                                            ) {
                                                              value += 0.1;
                                                              value *= 100;
                                                              value =
                                                                Math.round(
                                                                  value
                                                                );
                                                              value /= 100;
                                                            }
                                                          } else {
                                                            value = 0.0;
                                                          }
                                                          setValue(
                                                            "bonus-" +
                                                              product.productId,
                                                            value
                                                          );
                                                        }}
                                                        optionValue={
                                                          valueList &&
                                                          valueList[
                                                            category
                                                              .originalTitle
                                                          ] &&
                                                          valueList[
                                                            category
                                                              .originalTitle
                                                          ][
                                                            product.productName
                                                          ] &&
                                                          valueList[
                                                            category
                                                              .originalTitle
                                                          ][
                                                            product.productName
                                                          ].bonusValues.map(
                                                            (
                                                              bonusValue,
                                                              index
                                                            ) => {
                                                              return (
                                                                <option
                                                                  className="bonusComm-option-value"
                                                                  value={
                                                                    bonusValue !==
                                                                    "-"
                                                                      ? parseFloat(
                                                                          bonusValue.toFixed(
                                                                            2
                                                                          )
                                                                        )
                                                                      : "-"
                                                                  }
                                                                >
                                                                  {bonusValue !==
                                                                  "-"
                                                                    ? bonusValue.toFixed(
                                                                        2
                                                                      )
                                                                    : "-"}
                                                                </option>
                                                              );
                                                            }
                                                          )
                                                        }
                                                        value={value}
                                                        category={category}
                                                        product={product}
                                                        handleSelectCatValue={
                                                          handleSelectCatValue
                                                        }
                                                        handleSelectValue={
                                                          handleSelectValue
                                                        }
                                                        errors={errors}
                                                        type="maxBonus" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                                        section="referral"
                                                      />

                                                      <PlusMinusMaxButton
                                                        buttonSection="max"
                                                        styleValueButton={getValues('bonus-' + product.productId) == product.maxBonus}
                                                        text={t("MAX")}
                                                        category={category}
                                                        onClickMax={() =>
                                                          handleMaxBtn(
                                                            product.productId,
                                                            product.maxBonus,
                                                            product.maxCommission,
                                                            product.maxClubFee,
                                                            "bonus"
                                                          )
                                                        }
                                                        section="referral"
                                                      />
                                                    </>
                                                  );
                                                }}
                                              />
                                            </div>
                                          )}
                                          {product.maxCommission > 0 && (
                                            <div className="referral-edit-details mb-3">
                                              <Controller
                                                control={control}
                                                name={
                                                  "commission-" +
                                                  product.productId
                                                }
                                                defaultValue={0}
                                                render={({
                                                  onChange,
                                                  value,
                                                }) => {
                                                  if(value === product.maxCommission){
                                                    if(document.getElementById("product-" + product.productId + "-commission") !== null) {
                                                        document.getElementById("product-" + product.productId + "-commission").style.background = backgroundDarkMaxButton;
                                                    }
                                                  }
                                                  else {
                                                    if(document.getElementById("product-" + product.productId + "-commission") !== null) {
                                                      document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                    }
                                                  }

                                                  return (
                                                    <>
                                                      <div className="first font-12">
                                                        {t("COMMISSION_SHORT")}
                                                        <br />
                                                        {t("MAX") + " : "}
                                                        {product.maxCommission.toFixed(
                                                          2
                                                        )}
                                                        %
                                                      </div>

                                                      <PlusMinusMaxButton
                                                      category={category}
                                                      styleValueMinus={
                                                        product.maxCommission >
                                                          0 &&
                                                        (value !== "-"
                                                          ? parseFloat(
                                                              value.toFixed(2)
                                                            ) > 0
                                                          : true)
                                                      }
                                                      onClickMinus={(e) => {
                                                        if (value !== "-") {
                                                          if (
                                                            product.maxCommission >
                                                              0 &&
                                                            parseFloat(value) >
                                                              0
                                                          ) {
                                                            value -= 0.1;
                                                            value *= 100;
                                                            value =
                                                              Math.round(value);
                                                            value /= 100;

                                                            document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                          }
                                                          else if(value == product.maxCommission) {
                                                            document.getElementById("product-" + product.productId + "-commission").style.background = backgroundDarkMaxButton;
                                                          }
                                                        } 
                                                        else {
                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                          value = 0.0;
                                                        }
                                                        
                                                        setValue(
                                                          "commission-" +
                                                            product.productId,
                                                          value
                                                        );
                                                      }}
                                                      styleValuePlus={
                                                        product.maxCommission >
                                                          0 &&
                                                        (value !== "-"
                                                          ? parseFloat(
                                                              value.toFixed(2)
                                                            ) <
                                                            product.maxCommission
                                                          : true)
                                                      }

                                                      onClickPlus={(e) => {
                                                        if (value !== "-") {
                                                        if (
                                                          product.maxCommission >
                                                            0 &&
                                                          parseFloat(value) <
                                                            product.maxCommission
                                                        ) {
                                                          value += 0.1;
                                                          value *= 100;
                                                          value =
                                                            Math.round(value);
                                                          value /= 100;

                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                        }

                                                        else if(value == product.maxCommission) {
                                                          document.getElementById("product-" + product.productId + "-commission").style.background = backgroundDarkMaxButton;
                                                        }
                                                      }
                                                      else {
                                                        document.getElementById("product-" + product.productId + "-commission").style.background = backgroundLightMaxButton;
                                                        value = 0.0;
                                                      }
                                                        setValue(
                                                          "commission-" +
                                                            product.productId,
                                                          value
                                                        );
                                                      }}
                                                      buttonSection="plusminus"
                                                      optionValue={valueList[
                                                        category.originalTitle
                                                      ][
                                                        product.productName
                                                      ].commValues.map(
                                                        (commValue, index) => {
                                                          return (
                                                            <option
                                                              key={
                                                                "dg_comm_values_" +
                                                                index
                                                              }
                                                              className="bonusComm-option-value"
                                                              value={
                                                                commValue !==
                                                                "-"
                                                                  ? parseFloat(
                                                                      commValue.toFixed(
                                                                        2
                                                                      )
                                                                    )
                                                                  : "-"
                                                              }
                                                            >
                                                              {commValue !== "-"
                                                                ? commValue.toFixed(
                                                                    2
                                                                  )
                                                                : "-"}
                                                            </option>
                                                          );
                                                        }
                                                      )}
                                                      product={product}
                                                      value={value}
                                                      handleSelectValue={
                                                        handleSelectValue
                                                      }
                                                      errors={errors}
                                                      type="maxCommission" // type for bonus/commission/clubfee/maxBonus/maxCommission/maxClubfee
                                                      section="referral"
                                                    />

                                                      <PlusMinusMaxButton
                                                        buttonSection="max"
                                                        text={t("MAX")}
                                                        id={'product-' + product.productId + '-commission'}
                                                        onClickMax={() =>
                                                          handleMaxBtn(
                                                            product.productId,
                                                            product.maxBonus,
                                                            product.maxCommission,
                                                            product.maxClubFee,
                                                            "commission"
                                                          )
                                                        }
                                                        section="referral"
                                                      />
                                                    </>
                                                  );
                                                }}
                                              />
                                            </div>
                                          )}
                                          {product.productName === "D2 Poker" &&
                                            product.maxClubFee > 0 && (
                                              <div className="referral-edit-details mb-3">
                                                <Controller
                                                  control={control}
                                                  name={
                                                    "clubFee-" +
                                                    product.productId
                                                  }
                                                  defaultValue={0}
                                                  render={({
                                                    onChange,
                                                    value,
                                                  }) => {
                                                    if(value === product.maxClubFee){
                                                      if(document.getElementById("product-" + product.productId + "-clubFee") !== null) {
                                                          document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundDarkMaxButton;
                                                      }
                                                    }
                                                    else {
                                                      if(document.getElementById("product-" + product.productId + "-clubFee") !== null) {
                                                        document.getElementById("product-" + product.productId + "-clubFee").style.background = backgroundLightMaxButton;
                                                      }
                                                    }

                                                    return (
                                                      <>
                                                        <div className="first font-12">
                                                          {t("CLUB_FEE")}
                                                          <br />
                                                          {t("MAX") + " : "}
                                                          {product.maxClubFee.toFixed(
                                                            2
                                                          )}
                                                          %
                                                        </div>

                                                        <PlusMinusMaxButton
                                                          buttonSection="plusminus"
                                                          styleValueMinus={
                                                            product.maxClubFee >
                                                              0 &&
                                                            (value !== "-"
                                                              ? parseFloat(
                                                                  value.toFixed(
                                                                    2
                                                                  )
                                                                ) > 0
                                                              : true)
                                                          }
                                                          onClickMinus={(e) => {
                                                            if (value !== "-") {
                                                              if (
                                                                product.maxClubFee >
                                                                  0 &&
                                                                parseFloat(
                                                                  value
                                                                ) > 0
                                                              ) {
                                                                value -= 5.0;
                                                                value *= 100;
                                                                value =
                                                                  Math.round(
                                                                    value
                                                                  );
                                                                value /= 100;
                                                              }
                                                            } else {
                                                              value = 0.0;
                                                            }
                                                            setValue(
                                                              "clubFee-" +
                                                                product.productId,
                                                              value
                                                            );
                                                          }}
                                                          styleValuePlus={
                                                            product.maxClubFee >
                                                              0 &&
                                                            (value !== "-"
                                                              ? parseFloat(
                                                                  value.toFixed(
                                                                    2
                                                                  )
                                                                ) <
                                                                product.maxClubFee
                                                              : true)
                                                          }
                                                          onClickPlus={(e) => {
                                                            if (value !== "-") {
                                                              if (
                                                                product.maxClubFee >
                                                                  0 &&
                                                                parseFloat(
                                                                  value
                                                                ) <
                                                                  product.maxClubFee
                                                              ) {
                                                                value += 5.0;
                                                                value *= 100;
                                                                value =
                                                                  Math.round(
                                                                    value
                                                                  );
                                                                value /= 100;
                                                              }
                                                            } else {
                                                              value = 0.0;
                                                            }
                                                            setValue(
                                                              "clubFee-" +
                                                                product.productId,
                                                              value
                                                            );
                                                          }}
                                                          optionValue={
                                                            valueList &&
                                                            valueList[
                                                              category
                                                                .originalTitle
                                                            ] &&
                                                            valueList[
                                                              category
                                                                .originalTitle
                                                            ][
                                                              product
                                                                .productName
                                                            ] &&
                                                            valueList[
                                                              category
                                                                .originalTitle
                                                            ][
                                                              product
                                                                .productName
                                                            ].clubFeeValues.map(
                                                              (
                                                                clubFeeValue,
                                                                index
                                                              ) => {
                                                                return (
                                                                  <option
                                                                    className="bonusComm-option-value"
                                                                    value={
                                                                      clubFeeValue !==
                                                                      "-"
                                                                        ? parseFloat(
                                                                            clubFeeValue.toFixed(
                                                                              2
                                                                            )
                                                                          )
                                                                        : "-"
                                                                    }
                                                                  >
                                                                    {clubFeeValue !==
                                                                    "-"
                                                                      ? clubFeeValue.toFixed(
                                                                          2
                                                                        )
                                                                      : "-"}
                                                                  </option>
                                                                );
                                                              }
                                                            )
                                                          }
                                                          value={value}
                                                          category={category}
                                                          product={product}
                                                          handleSelectValue={
                                                            handleSelectValue
                                                          }
                                                          errors={errors}
                                                          type="maxClubFee" // type for bonus/commission/clubFee/maxBonus/maxCommission/maxClubfee
                                                          section="referral"
                                                        />
                                                        
                                                          <PlusMinusMaxButton
                                                            buttonSection="max"
                                                            text={t("MAX")}
                                                            id={'product-' + product.productId + '-clubFee'}
                                                            onClickMax={() =>
                                                              handleMaxBtn(
                                                                product.productId,
                                                                product.maxBonus,
                                                                product.maxCommission,
                                                                product.maxClubFee,
                                                                "clubFee"
                                                              )
                                                            }
                                                            section="referral"
                                                          />
                                                      </>
                                                    );
                                                  }}
                                                />
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    );
                                  })}
                            </div>
                          </>
                        );
                      }
                    )}
                  </TabPane>
                )}
            </TabContent>
            <button className="custom-btn-style-1">{t("SAVE")}</button>
          </form>
        ) : (
          <div className="loading-spinner-wrapper">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <section className="section-padding" id="referral-edit-section">
        <div className="container">
          <div className="row">
            <div className="col-3" id="account-menu">
              <Sidebar activePage={"REFERRAL"} />
            </div>
            <div className="col-9">
              <ContentHeader enableBackButton title={t(contentTitle)} />
              <hr className="right-title-hr" />
              {initCheck && ReferralCodeDetailForm()}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ReferralEdit;
